<template id="ctFormCreateOrgTmpl">
	<v-dialog v-model="dialogCreateOrgIsOpen" persistent max-width="500px">
		<template v-slot:activator="{ on }">
			<v-btn v-on="on" class="button-main ma-1"><v-icon left dark>add</v-icon>{{ $t('btn.addOrg')}}</v-btn>
		</template>
		
		<v-form ref="form" v-model="valid" lazy-validation>
			<v-card>
				<v-card-title><span class="headline">{{ $t('lbl.newOrganization')}}</span></v-card-title>

				<v-card-text>
					<v-layout row wrap>
					<v-flex xs12><v-text-field v-model="newOrganization.name" :rules="nameRules" :label="$t('lbl.organizationName')" required></v-text-field></v-flex>
					</v-layout>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn class="button-main ma-1" v-on:click.native="dialogCreateOrgIsOpen = false"> <v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
					<v-btn class="button-main ma-1" v-on:click="createNewOrganization()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.createNewOrganization')}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>

	</v-dialog>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
    data: () => ({
		dialogCreateOrgIsOpen: false,
		valid: false,
		nameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		newOrganization: {name: ''}
	}),
	methods: {
		createNewOrganization() {
			if (this.$refs.form.validate()) {
				var obj2send =  { organization_name: this.newOrganization.name };
				console.log("CREATE ORGANIZATION: " + constants.ENDPOINT_ORGANIZATIONS);	
				console.log(JSON.stringify(obj2send));	
				this.$root.genericPostAuthenticatedCallEngine(constants.ENDPOINT_ORGANIZATIONS, obj2send, this.callbackCreateNewOrganization);	
			}	
		},
		callbackCreateNewOrganization(responseData) {
			this.dialogCreateOrgIsOpen= false;
			
			// RE-LOAD ORGANIZATIONS
			events.$emit('newOrgCreated');

			this.$root.setDialogMsg(i18n.t('msg.saveok'));
		},
	}	
}
</script>